export const snackbarDurationInMilliseconds = 5000;
export const defaultRowsPerPageOptions = [5, 10, 25];
